import * as PIXI from 'pixi.js';
import { commonPropertySetters } from '../../../pixi/commonPropertySetters';
import { construct } from '../../../helpers/commonInitializer';

export class Container extends PIXI.Container {
  constructor(options) {
    super();
    this.roundPixels = true;
    construct.call(this, options);
  }

  applyStyles(styles = {}) {
    if (Array.isArray(styles)) styles = styles.reduce((r, c) => Object.assign(r, c), {});
    for (const prop in styles) {
      const value = styles[prop];
      if (commonPropertySetters[prop]) commonPropertySetters[prop].call(this, value);
    }
  }

  hide() {
    this.visible = false;
  }

  show() {
    this.visible = true;
  }
}
